module.exports = __webpack_public_path__ + "assets/img/energy-live.be96ad6b.png";